<div class="col-12 col-xl-8">
  <div class="entity-binding-workspace bg-white bg-opacity-75 rounded-4 border shadow p-3 h-100">
    <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-1">
      <div>
        <p class="fw-bold mb-1 text-x">Manual Verification Rules</p>
        <div class="entity-panel-caption text-xs fw-semibold">
          Define which manual checks must be completed for this entity.
        </div>
      </div>
      <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">
        {{ bindings_count }} Active
      </span>
    </div>

    <div class="entity-new-binding-card bg-white rounded-4 border p-3 mb-3 mt-3 shadow">
      <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap">
        <div class="d-flex align-items-start gap-2">
          <div class="entity-new-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center">
            <i class="bi bi-clipboard-check"></i>
          </div>
          <div>
            <div class="fw-bold text-xs mb-1">Add Manual Verification</div>
            <div class="entity-panel-caption text-xxs fw-semibold">
              Example: KYC (annual), Site Visit (one-off), Bank Account Proof (annual).
            </div>
          </div>
        </div>

        <button
          type="button"
         class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
          @click="open_bind_modal"
        >
          <i class="bi bi-plus-lg me-2"></i>
          Create Binding
        </button>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
      <div class="fw-bold small">Current Manual Verifications</div>
    </div>

    <div class="d-flex flex-column gap-2">
      <div
        v-for="binding in bindings"
        :key="binding.id"
        class="entity-binding-list-card bg-white d-flex align-items-start justify-content-between gap-3 rounded-4 p-3 shadow-sm"
      >
        <div class="d-flex align-items-start gap-3 flex-grow-1 overflow-hidden">
          <div
            class="entity-summary-icon mt-2 ms-2 rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 align-self-stretch"
          >
            <i class="bi bi-clipboard-check fs-4"></i>
          </div>
          <div class="flex-grow-1 overflow-hidden">
            <div class="fw-bold small text-truncate mb-1 text-uppercase">
              {{ binding.verification_type || 'manual_verification' }}
            </div>

            <div class="d-flex flex-wrap gap-2 mt-1">
              <span class="badge rounded-pill text-bg-light border text-secondary text-xxs fw-semibold">
                Cadence: {{ format_cadence_kind(binding.cadence_kind) }}
              </span>
              <span
                v-if="String(binding.cadence_kind) === 'periodic'"
                class="badge rounded-pill text-bg-light border text-secondary text-xxs fw-semibold"
              >
                Interval: {{ format_days_from_seconds(binding.recurrence_interval_seconds) }}
              </span>
              <span class="badge rounded-pill text-bg-light border text-secondary text-xxs fw-semibold">
                Grace: {{ format_days_from_seconds(binding.grace_period_seconds) }}
              </span>
              <span
                v-if="binding.manual_verification_form_name || binding.verification_form_name"
                class="badge rounded-pill text-bg-light border text-secondary text-xxs fw-semibold"
              >
                Form: {{ binding.manual_verification_form_name || binding.verification_form_name }}
              </span>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column align-items-end gap-2 flex-shrink-0">
          <button
            type="button"
            class="btn btn-link btn-sm p-0 text-primary text-decoration-none small fw-semibold d-inline-flex align-items-center justify-content-end gap-2 text-nowrap"
            :disabled="creating_binding || removing_binding_id === binding.id"
            @click="open_edit_modal(binding)"
          >
            <i class="bi bi-pencil-square"></i>
            Edit
          </button>
          <button
            type="button"
            class="btn btn-link btn-sm p-0 text-danger text-decoration-none small fw-semibold d-inline-flex align-items-center justify-content-end gap-2 text-nowrap"
            :disabled="removing_binding_id === binding.id"
            @click="remove_binding(binding)"
          >
            <i class="bi bi-trash3"></i>
            {{ removing_binding_id === binding.id ? 'Removing...' : 'Remove' }}
          </button>
        </div>
      </div>

      <div v-if="!bindings.length" class="entity-activity-card rounded-4 p-3 small text-secondary bg-white">
        No manual verification rules yet. Add a rule above.
      </div>
    </div>
  </div>
</div>

<div class="col-12 col-xl-4">
  <div class="entity-overview-profile-card rounded-4 border shadow p-4 h-100 overflow-hidden">
    <h2 class="entity-overview-title fw-bold mb-3">Verification Context</h2>
    <div class="small mb-4">
      <div class="entity-panel-caption fw-semibold">Configuring verification for</div>
      <div class="fw-bold">{{ entityTypeName || 'Entity' }}</div>
    </div>

    <div class="d-flex flex-column gap-3 my-4">
      <div class="d-flex align-items-center justify-content-between gap-2">
        <span class="small text-secondary">Manual rules</span>
        <span class="small fw-bold">{{ bindings_count }}</span>
      </div>
    </div>

    <button
      type="button"
      class="btn entity-overview-profile-btn rounded-small w-100 text-xs fw-semibold"
      @click="go_to_entity_overview"
    >
      <i class="bi bi-eye me-2"></i>
      View Entity Overview
    </button>
  </div>
</div>

<teleport to="body">
  <div
    v-if="show_bind_modal"
    class="modal fade show d-block"
    tabindex="-1"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-4 p-0 shadow-lg overflow-hidden">
        <div class="modal-header border-0 cute-header shadow-lg d-flex align-items-start justify-content-between gap-3">
          <div class="d-flex align-items-start gap-2">
            <div
              class="entity-new-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0"
            >
              <i class="bi bi-clipboard-check"></i>
            </div>
            <div>
              <div class="modal-title text-white fw-bold small mb-0">
                {{ editing_binding_id ? 'Edit Manual Verification Rule' : 'Create Manual Verification Rule' }}
              </div>
              <div class="text-white-50 text-xxs fw-semibold">
                Configure cadence and due-window settings.
              </div>
            </div>
          </div>
          <button
            type="button"
            class="modal-btn-close btn-close"
            aria-label="Close"
            @click="close_bind_modal"
          ></button>
        </div>

        <div class="modal-body p-3 p-md-4">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label mb-1 fw-semibold text-xs">Mapped manual verification form</label>
              <select
                v-model="binding_form.manual_form_link_id"
                class="form-select rounded-small p-2 shadow-sm text-xs"
                :disabled="loading_manual_form_links"
              >
                <option value="">
                  {{ loading_manual_form_links ? 'Loading mapped forms...' : 'Select mapped form...' }}
                </option>
                <option
                  v-for="link in manual_form_link_options"
                  :key="link.id"
                  :value="link.id"
                >
                  {{ link.manual_verification_form_name }}
                </option>
              </select>
              <div class="entity-panel-caption text-xxs fw-semibold mt-1">
                Select the manual verification form this rule should use.
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label mb-1 fw-semibold text-xs">Verification type</label>
              <select v-model="binding_form.verification_type" class="form-select rounded-small p-2 shadow-sm text-xs">
                <option
                  v-for="option in verification_type_options"
                  :key="option.value || option.label"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
              <div class="entity-panel-caption text-xxs fw-semibold mt-1">
                Select the verification category the onboarding run should open.
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label mb-1 fw-semibold text-xs">Cadence kind</label>
              <select v-model="binding_form.cadence_kind" class="form-select rounded-small p-2 shadow-sm text-xs">
                <option v-for="option in cadence_kind_options" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>

            <div class="col-12" v-if="is_periodic">
              <label class="form-label mb-1 fw-semibold text-xs">Recurrence interval</label>
              <div class="input-group shadow-sm">
                <select v-model.number="binding_form.recurrence_interval_seconds" class="form-select rounded-small p-2 text-xs">
                  <option v-for="option in recurrence_interval_options" :key="option.seconds" :value="option.seconds">
                    {{ option.label }}
                  </option>
                </select>
                <span class="input-group-text bg-light text-xs fw-semibold">
                  {{ format_seconds(binding_form.recurrence_interval_seconds) }} s
                </span>
              </div>
            </div>

            <div class="col-12" v-if="is_periodic">
              <label class="form-label mb-1 fw-semibold text-xs">Grace period</label>
              <div class="input-group shadow-sm">
                <select v-model.number="binding_form.grace_period_seconds" class="form-select rounded-small p-2 text-xs">
                  <option v-for="option in grace_period_options" :key="option.seconds" :value="option.seconds">
                    {{ option.label }}
                  </option>
                </select>
                <span class="input-group-text bg-light text-xs fw-semibold">
                  {{ format_seconds(binding_form.grace_period_seconds) }} s
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 p-3 d-flex justify-content-end gap-2 bg-body-tertiary">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm rounded-small px-3"
            :disabled="creating_binding"
            @click="close_bind_modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn entity-create-binding-btn btn-sm rounded-small shadow-sm px-3 fw-semibold border-0 text-white"
            :disabled="creating_binding"
            @click="submit_binding"
          >
            <i :class="editing_binding_id ? 'bi bi-check2 me-2' : 'bi bi-plus-lg me-2'"></i>
            {{ creating_binding ? 'Saving...' : (editing_binding_id ? 'Update Rule' : 'Save Rule') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show_bind_modal" class="modal-backdrop fade show"></div>
</teleport>

